import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Luiz Carlos Jr.',
      company: '',
      text: 'Ótimo profissional, atendimento de qualidade.',
      rating: 5
    },
    {
      name: 'Saulo Rakovski',
      company: '',
      text: 'Tenho uma experiência muito positiva com a TALC. A equipe demonstra um excelente conhecimento técnico, aliado a um atendimento humanizado e eficiente.',
      rating: 5
    },
    {
      name: 'Alexandre Sartori',
      company: '',
      text: 'Excelente o atendimento e a orientação passada pelo profissional. Eu definitivamente recomendo.',
      rating: 5
    },
    {
      name: 'Aline Guerreiro',
      company: '',
      text: 'Muito bom o atendimento, ágil e prestativo, excelente profissionais',
      rating: 5
    },
    {
      name: 'Fruteira Missões',
      company: '',
      text: 'Ótimo atendimento! O pessoal é paciente e eficiente. Agregou muito no meu negócio! Recomendo!',
      rating: 5
    },
    {
      name: 'Jorge Figueireido',
      company: '',
      text: 'Excelente atendimento, ótimos profissionais, recomendo!',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-[#e5e5e5]/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#c99b36] font-semibold text-lg mb-2 block">Depoimentos</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a4b3c] mb-4">
            O Que Nossos Clientes Dizem
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            A satisfação dos nossos clientes é nossa maior recompensa
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 relative border border-gray-100"
            >
              <Quote className="absolute top-6 right-6 text-[#c99b36]/20 w-12 h-12" />
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={20} className="fill-[#c99b36] text-[#c99b36]" />
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed mb-6 relative z-10">
                "{testimonial.text}"
              </p>

              <div className="border-t border-[#e5e5e5] pt-4">
                <p className="font-bold text-[#0a4b3c] text-lg">{testimonial.name}</p>
                <p className="text-gray-500 text-sm">{testimonial.company}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Seção do Parceiro */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="mt-20 bg-white rounded-xl p-8 shadow-lg border border-gray-100"
      >
        <div className="flex flex-col md:flex-row items-center gap-8">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex-shrink-0"
          >
            <img
              src="/images/grpw-logo.png"
              alt="GRPW Advocacia Especializada"
              className="h-36 w-auto object-contain"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="flex-1 text-center md:text-left"
          >
            <h3 className="text-4xl font-bold text-[#0a4b3c] mb-4">Nosso Parceiro</h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Contamos com o apoio da GRPW Advocacia Especializada, um escritório de advocacia comprometido com a excelência jurídica e o atendimento personalizado aos nossos clientes. Nossa parceria garante suporte completo em questões legais, complementando nossos serviços contábeis para oferecer soluções integradas e abrangentes para o seu negócio.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Juntos, trabalhamos para proporcionar tranquilidade e segurança jurídica, assegurando que todos os aspectos legais e contábeis do seu empreendimento estejam em conformidade e otimizados para o sucesso.
            </p>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default Testimonials;